import React, {useState} from "react";
import {
  Button,
  Card,
  CardText,
  CardTitle,
  Grid,
  TableColumn,
  SelectField,
  Cell,
  TextField,
} from "react-md";
import { Tabs, Tab } from 'react-md';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { CSVLink } from "react-csv";
import "../../css/mediaCss.css";
import Toggle from "react-toggle";
import { colorsArray, getColorsArrayDisPlayOrder, AngleDisplayOptions } from "./commonHelpers";
import trashIcon from '../../images/png/trashIcon.png';
import deleteIcon from '../../images/png/deleteIcon.png';
import rigtArrowIcon from '../../images/png/right-arrow.png';
import leftArrowIcon from '../../images/png/left-arrow.png';
import plus from '../../images/png/plus.png';
const ITEMS_PER_PAGE = 5;
const VectorVariableOption = (props) => {
  const { classNameString, data,onAddVectorAnswer,onRemoveVectorAnswer } = props;
  const [activeVectorIndex, setActiveVectorIndex] = useState(data?.length-1); // Currently selected vector
  const [currentPage, setCurrentPage] = useState(0); // For paginating the vector icons
  const totalPages = Math.ceil(data?.length / ITEMS_PER_PAGE);

  // Get the icons for the current page
  const displayedIcons = data?.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE
  );

  const onVectorDeleteConfirm =(i) =>   {
    confirmAlert({
      title: 'Do you really want to delete this vector ?',
      message: 'Press Confirm to submit',

      cancelLabel: 'Confirm',
      confirmLabel: 'Cancel',
      onCancel: () => onRemoveVectorAnswer(i)
    });
}
  const isAnglevalid =(variableObj) =>   {
      return variableObj.inputType === "angle-magnitude" && (variableObj.variableType === "INT" || variableObj.variableType === "FLOAT" );
  }
  const isCompValid =  (variableObj) =>   {
    return variableObj.inputType === "components" && (variableObj.variableType === "RANGE" || variableObj.variableType === "LIST" );
}

  if (!data) return null;

  return (
    <Card className={classNameString} style={{ marginLeft: "0px" }}>
      <div style={{display:"flex"}}>

          <CardTitle
            title="Vectors Configuration"
            subtitle="Edit variables used in the Answer"
            className="variable-table-card-title"
          />
      {/* Vector Icons with Pagination */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px',marginTop: "20px",
         marginLeft: "25px" }}>
        {
          currentPage !== 0 ?

          <Button
            disabled={currentPage === 0}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            <img style={{marginTop:"22px"}} src={leftArrowIcon} alt="Prev" />
          </Button> : ""
        }

        {displayedIcons?.map((variableObj, i) => {
          const globalIndex = currentPage * ITEMS_PER_PAGE + i;
          return (
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <Button
                  key={globalIndex}
                  style={{
                    padding: '2px',
                    margin: '2px',
                    color: activeVectorIndex === globalIndex ? 'white' : '#bb0000',
                    backgroundColor: activeVectorIndex === globalIndex ? '#bb0000' : 'white',
                    marginTop: "20px"
                  }}
                  flat
                  onClick={() => setActiveVectorIndex(globalIndex)}
                >
                  {variableObj.name}
                </Button>

                {/* Delete button positioned to the top-right of the above button */}
                {   data?.length > 1 ? 

                    <Button
                      icon
                      tooltipLabel="Delete"
                      style={{
                        position: 'absolute',
                        top: '0px',  // Adjust the top position to place it at the desired point
                        right: '-14px',  // Adjust the right position for alignment
                        marginLeft: "45px",
                        marginBottom: "20px"
                      }}
                      onClick={() => onVectorDeleteConfirm(i)}
                    >
                      <img src={deleteIcon} alt="Delete" />
                    </Button>
                : ""}
                
              </div>
              
          );
        })}
       {
          currentPage !== totalPages - 1 ?

          <Button
          disabled={currentPage === totalPages - 1}
          onClick={() => setCurrentPage((prev) => prev + 1)}
        >
           <img style={{marginTop:"22px"}} src={rigtArrowIcon} alt="Next" />
          
        </Button>: ""
        }
      

        <Button
              icon
              tooltipLabel="Add Vector"
              onClick={onAddVectorAnswer}
              style={{marginTop:"12px",marginLeft:"20px"}}
            >
            <img src={plus} alt="Delete" />
          </Button>

      </div>
      </div>
      {data?.length > 0 && (
        <div>
          <CardText  style={{display:"flex",overflow:"scroll",maxWidth:"900px"}}>
          {data?.length > 0 &&
          
          <div>
                            <Grid key={activeVectorIndex}  style={{minWidth:"500px",borderRight:"1px solid black"}}>
                
                <Cell size={3}>
                  <TextField
                    className="textFieldClass heightLight"
                    disabled
                    value={data[activeVectorIndex].name}
                    label={"Vector-"+ (activeVectorIndex+1)}
                    id={`text-field-${activeVectorIndex}`}
                  />
                </Cell>
                <Cell size={3}>
                  <SelectField
                    id={`text-color-${activeVectorIndex}`}
                    label="Color"
                    fullWidth
                    onChange={(value) => {
                      data[activeVectorIndex].color = value;
                      props.onTableRowChange(data[activeVectorIndex]);
                    }}
                    menuItems={colorsArray}
                    value={data[activeVectorIndex].color}
                  />
                </Cell>
                <Cell size={3}>
                  <SelectField
                    id={`variable-type-${activeVectorIndex}`}
                    label="Type"
                    fullWidth
                    onChange={(value) => {
                      data[activeVectorIndex].inputType = value;
                      if (value === "components") {
                        data[activeVectorIndex].variableType = "RANGE";
                      } else {
                        data[activeVectorIndex].variableType = "INT";
                      }
                      
                      props.onTableRowChange(data[activeVectorIndex]);
                    }}
                    menuItems={["components", "angle-magnitude"]}
                    value={data[activeVectorIndex].inputType}
                  />
                </Cell>
                <Cell size={3}>
                  {data[activeVectorIndex].inputType === "components" ? (
                    <SelectField
                      id={`variable-type1-${activeVectorIndex}`}
                      label="Type"
                      onChange={(value) => {
                        data[activeVectorIndex].variableType = value;
                        props.onTableRowChange(data[activeVectorIndex]);
                      }}
                      menuItems={["RANGE", "LIST"]}
                      value={data[activeVectorIndex].variableType}
                    />
                  ) : (
                    <SelectField
                      helpText="Select a vector variable type"
                      id={`variable-type1-${activeVectorIndex}`}
                      label="Type"
                      onChange={(value) => {
                        data[activeVectorIndex].variableType = value;
                        props.onTableRowChange(data[activeVectorIndex]);
                      }}
                      style={{width:"109px"}}
                      menuItems={["INT", "FLOAT"]}
                      value={data[activeVectorIndex].variableType}
                    />
                  )}
                     {   data?.length > 1 ? 

                        <Button icon tooltipLabel="Delete" 
                        style={{marginLeft:"10px",marginBottom:"20px"}}
                        onClick={() => onVectorDeleteConfirm(activeVectorIndex)}>
                                    <img src={trashIcon} alt="Delete"  />
                          </Button> : ""
                     }
                  
                </Cell>
              
                {(isCompValid || isAnglevalid) && <GetRow1 variableObj={data[activeVectorIndex]} i={activeVectorIndex} props={props} />}
                 {(isCompValid || isAnglevalid) && <GetRow2 variableObj={data[activeVectorIndex]} i={activeVectorIndex} props={props} />}
              
                
                <Cell size={3}>
                  <label
                    htmlFor={`show-label-check-${activeVectorIndex}`}
                    className="vectors-toggle-label"
                  >
                    {"Show Label"}
                  </label>
                  <Toggle
                    icons={false}
                    width={230}
                    id={`show-label-check-${activeVectorIndex}`}
                    name="Show Label"
                    onChange={(event) => {
                      data[activeVectorIndex].showLabel = event.target.checked;
                      props.onTableRowChange(data[activeVectorIndex]);
                    }}
                    checked={data[activeVectorIndex].showLabel}
                  />
                </Cell>
                <Cell size={3}>
                  <label
                    htmlFor={`show-angle-check-${activeVectorIndex}`}
                    className="vectors-toggle-label"
                  >
                    {"Show Angle"}
                  </label>
                  <Toggle
                    icons={false}
                    width={230}
                    id={`show-angle-check-${activeVectorIndex}`}
                    name="Show Angle"
                    onChange={(event) => {
                      data[activeVectorIndex].showAngle = event.target.checked;
                      props.onTableRowChange(data[activeVectorIndex]);
                    }}
                    checked={data[activeVectorIndex].showAngle}
                    className="rp-fraction-checkbox"
                    label="Show Angle"
                  />
                </Cell>
                <Cell size={3}>
                  <label
                    htmlFor={`show-components-check-${activeVectorIndex}`}
                    className="vectors-toggle-label"
                  >
                    {"Component"}
                  </label>
                  <Toggle
                    icons={false}
                    width={230}
                    id={`show-components-check-${activeVectorIndex}`}
                    name="Show Components"
                    onChange={(event) => {
                      data[activeVectorIndex].showComponents = event.target.checked;
                      props.onTableRowChange(data[activeVectorIndex]);
                    }}
                    checked={data[activeVectorIndex].showComponents}
                    className="rp-fraction-checkbox"
                    label="Show Components"
                  />
                </Cell>
                <Cell size={3}>
                  <label
                    htmlFor={`auto-origin-check-${activeVectorIndex}`}
                    className="vectors-toggle-label"
                  >
                    {"Center Origin"}
                  </label>
                  <Toggle
                    icons={false}
                    width={230}
                    id={`auto-origin-check-${activeVectorIndex}`}
                    name="Auto Origin"
                    onChange={(event) => {
                      data[activeVectorIndex].autoOrigin = event.target.checked;
                      props.onTableRowChange(data[activeVectorIndex]);
                    }}
                    checked={data[activeVectorIndex].autoOrigin}
                    className="rp-fraction-checkbox"
                    label="Auto Origin"
                  />
                </Cell>
                <br />
                <AngleOptions
                  variableObj={data[activeVectorIndex]}
                  activeVectorIndex={activeVectorIndex}
                  props={props}
                  visible={data[activeVectorIndex].showAngle}
                />
                </Grid>
          </div>
          }
          </CardText> 
        </div>)
      }

    </Card>
  );
};

const ListValuesSection = (props) => {
  let variableObj = props.variableObj;
  let field = props.field;

  const csvData = [
    [
      "In column 1 enter the Question [variable] values",
      "In columns 2 through n enter the n correct answer value(s)",
    ],
    ["Australia", "Melbourne", "Sydney", "Perth"],
    ["India", "New Delhi", "Mumbai", "Chennai"],
    ["USA", "Columbus", "New York", "San Francisco"],
  ];
  return (
    <TableColumn>
      <TextField
        id="list-values"
        placeholder={props.placeholder}
        type="text"
        label={props.fieldName}
        value={variableObj[field] || ""}
        helpText={props.helpText}
        onChange={(value) => {
          variableObj[field] = value;
          props.onTableRowChange(variableObj);
        }}
      />
    
    </TableColumn>
  );
};

const GetRow1 = ({variableObj, i, props}) => {

  const [errorXorigin,setErrorXorigin] = useState(false);
  const [xoriginHelperText,setXoriginHelperText] = useState('');
  const [errorXmin,setErrorXmin] = useState(false);
  const [xminHelperText,setXminHelperText] = useState('');
  const [errorXmax,setErrorXmax] = useState(false);
  const [xmaxHelperText,setXmaxHelperText] = useState('');
  const [errorMagmin,setErrorMagmin] = useState(false);
  const [magminHelperText,setMagminHelperText] = useState('');
  const [errorMagmax,setErrorMagmax] = useState(false);
  const [magmaxHelperText,setMagmaxHelperText] = useState('');

const getfirstInput = (type) => {
  return type === "components" ? "vectorBlackListX" : "vectorBlackListMagnitude";
}

const onXoriginChange = () => {
  if(variableObj.posX != ""){
  if(Number(variableObj.posX) < 0 || Number(variableObj.gridWidthUnit) <= Number(variableObj.posX)){
    setErrorXorigin(true);
    setXoriginHelperText(`Vector ${variableObj.name} is going outside the grid.`); 
  }else{
    setErrorXorigin(false);
    setXoriginHelperText('');
  }
 }
 onXmaxChange()
 onXminChange()
}

const onMagminChange = () => {
  if(variableObj.inputType === "angle-magnitude") {
    if(variableObj.magMin != ""){
      if(Number(variableObj.magMax) < Number(variableObj.magMin)) {
        setErrorMagmin(true);
        setMagminHelperText(`mag-min cannot be greater than mag-max`)
      }else{
        setErrorMagmin(false);
        setMagminHelperText('');
      } 
    }           
   }
}

const onMagmaxChange = () => {
  if(variableObj.inputType === "angle-magnitude") {
    if(variableObj.magMax != ""){
      if(Number(variableObj.magMax) < Number(variableObj.magMin)) {
        setErrorMagmax(true);
        setMagmaxHelperText(`mag-max cannot be less than mag-min`)
      }else{
        setErrorMagmax(false);
        setMagmaxHelperText('');
      } 
    }           
   }
}

const onXminChange = () => {
  if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
    if(variableObj.xMin != ""){
      if(Number(variableObj.xMax) < Number(variableObj.xMin)) {
        setErrorXmin(true);
        setXminHelperText(`x-min cannot be greater than x-max`)
      }else if(Number(variableObj.xMin) < -Number(variableObj.posX)){
        setErrorXmin(true);
        setXminHelperText(`Vector ${variableObj.name} is going outside the grid`)
      }
      else{
        setErrorXmin(false);
        setXminHelperText('');
      } 
    }           
   }
}

const onXmaxChange = () => {
  if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
    if(variableObj.xMax != ""){
      if(Number(variableObj.xMax) < Number(variableObj.xMin)) {
        setErrorXmax(true);
        setXmaxHelperText(`x-max cannot be less than x-min`)
      }else if(Number(variableObj.xMax) > Number(variableObj.gridWidthUnit - variableObj.posX)){
        setErrorXmax(true);
        setXmaxHelperText(`Vector ${variableObj.name} is going outside the grid`)
      }
      else{
        setErrorXmax(false);
        setXmaxHelperText('');
      } 
    }           
   }
}

  return (
    <React.Fragment>
        <Grid>
          <Cell size={3}>
              <TextField
                className="textFieldClass"
                error={errorXorigin}
                value={variableObj.posX ? variableObj.posX : ""}
                disabled={variableObj.autoOrigin}
                label="origin-x"
                type="number"
                id={`text-x-${i}`}
                onChange={(value) => {
                  variableObj.posX = value;
                  props.onTableRowChange(variableObj);
                  onXoriginChange();
                }}
              />
            </Cell>
            {
              variableObj.inputType === "components" ? (
                <>
                {variableObj.variableType === "RANGE" ? (
                  <React.Fragment>
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        error={errorXmin}
                        value={variableObj.xMin}
                        label="x-min"
                        type="number"
                        id={`text-x-${i}`}
                        onChange={(value) => {
                          variableObj.xMin = value;
                          props.onTableRowChange(variableObj);
                          onXminChange();
                        }}
                        helpText={errorXmin ? xminHelperText:"x-component min"}
                      />
                    </Cell>
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        error={errorXmax}
                        value={variableObj.xMax}
                        label="x-max"
                        type="number"
                        id={`text-x-${i}`}
                        onChange={(value) => {
                          variableObj.xMax = value;
                          props.onTableRowChange(variableObj);
                          onXmaxChange();
                        }}
                        helpText={errorXmax ? xmaxHelperText:"x-component max "}
                      />
                    </Cell>
                  </React.Fragment>
                ) : <ListValuesSection 
                      variableObj={variableObj}
                      field="xList"
                      fieldName="List for X"
                      placeholder='Enter list values seperated by comma " , " '
                      helpText="Enter values seperated by comma eg: 1,2.5,3,4,5"
                      onTableRowChange={props.onTableRowChange}
                />}
                </>
              ): (
                <>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error = {errorMagmin}
                    value={variableObj.magMin}
                    label="mag-min"
                    type="number"
                    id={`mag-min-${i}`}
                    onChange={(value) => {
                      variableObj.magMin = value ? value : 0;
                      props.onTableRowChange(variableObj);
                      onMagminChange();
                    }}
                    helpText={errorMagmin ? magminHelperText:"magnitude of vector "}
                  />
                </Cell>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error = {errorMagmax}
                    value={variableObj.magMax}
                    label="mag-max"
                    type="number"
                    id={`mag-max-${i}`}
                    onChange={(value) => {
                      variableObj.magMax = value ? value : 0;
                      props.onTableRowChange(variableObj);
                      onMagmaxChange();
                    }}
                    helpText={errorMagmax ? magmaxHelperText:"magnitude of vector "}
                  />
                </Cell>
                </>
              )
            }
            {(variableObj.variableType === "RANGE") || (variableObj.inputType === "angle-magnitude") ? (
                <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      id="text-black-list-x"
                      label={`Excluded List for ${variableObj.inputType === "components" ? "X" : "magnitide"}`}
                      placeholder="Multiple values must be comma separated"
                      type="text"
                      helpText="comma separated"
                      onChange={(value) => {
                        variableObj[getfirstInput(variableObj.inputType)] = value;
                        props.onTableRowChange(variableObj);
                      }}
                      value={variableObj[getfirstInput(variableObj.inputType)] || ""}
                    />
                  </Cell>
                </React.Fragment>
              ) : null}

        </Grid>
      </React.Fragment>
  )
};

const GetRow2 = ({variableObj, i, props}) => {
  
  const [errorYorigin,setErrorYorigin] = useState(false);
  const [yoriginHelperText,setYoriginHelperText] = useState('');
  const [errorYmin,setErrorYmin] = useState(false);
  const [yminHelperText,setYminHelperText] = useState('');
  const [errorYmax,setErrorYmax] = useState(false);
  const [ymaxHelperText,setYmaxHelperText] = useState('');
  const [errorAngmin,setErrorAngmin] = useState(false);
  const [angminHelperText,setAngminHelperText] = useState('');
  const [errorAngmax,setErrorAngmax] = useState(false);
  const [angmaxHelperText,setAngmaxHelperText] = useState('');

  const getsecondInput = (type) => {
    return type === "components" ? "vectorBlackListY" : "vectorBlackListAngle";
  } 

  const onYoriginChange = () => {
    if(variableObj.posY != ""){
    if(Number(variableObj.posY) < 0 || Number(variableObj.gridHeightUnit) <= Number(variableObj.posY)){
      setErrorYorigin(true);
      setYoriginHelperText(`Vector ${variableObj.name} is going outside the grid.`); 
    }else{
      setErrorYorigin(false);
      setYoriginHelperText('');
    }
   }
    onYmaxChange()
    onYminChange()
  }

  const onAngminChange = () => {
    if(variableObj.inputType === "angle-magnitude") {
      if(variableObj.angleMin != ""){
        if(Number(variableObj.angleMax) < Number(variableObj.angleMin)) {
          setErrorAngmin(true);
          setAngminHelperText(`angle-min cannot be greater than angle-max`)
        }else{
          setErrorAngmin(false);
          setAngminHelperText('');
        } 
      }           
     }
  }
  
  const onAngmaxChange = () => {
    if(variableObj.inputType === "angle-magnitude") {
      if(variableObj.angleMax != ""){
        if(Number(variableObj.angleMax) < Number(variableObj.angleMin)) {
          setErrorAngmax(true);
          setAngmaxHelperText(`angle-max cannot be less than angle-min`)
        }else{
          setErrorAngmax(false);
          setAngmaxHelperText('');
        } 
      }           
     }
  }

  const onYminChange = () => {
    if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
      if(variableObj.yMin != ""){
        if(Number(variableObj.yMax) < Number(variableObj.yMin)) {
          setErrorYmin(true);
          setYminHelperText(`y-min cannot be greater than y-max`)
        }else if(Number(variableObj.yMin) < -Number(variableObj.posY)){
          setErrorYmin(true);
          setYminHelperText(`Vector ${variableObj.name} is going outside the grid`)
        }
        else{
          setErrorYmin(false);
          setYminHelperText('');
        } 
      }           
     }
  }
  
  const onYmaxChange = () => {
    if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
      if(variableObj.yMax != ""){
        if(Number(variableObj.yMax) < Number(variableObj.yMin)) {
          setErrorYmax(true);
          setYmaxHelperText(`y-max cannot be less than y-min`)
        }else if(Number(variableObj.yMax) > Number(variableObj.gridHeightUnit - variableObj.posY)){
          setErrorYmax(true);
          setYmaxHelperText(`Vector ${variableObj.name} is going outside the grid`)
        }
        else{
          setErrorYmax(false);
          setYmaxHelperText('');
        } 
      }           
     }
  }
 
  return (
    <React.Fragment>
        <Grid>
          
            <Cell size={3}>
              <TextField
                className="textFieldClass"
                error ={errorYorigin}
                disabled={variableObj.autoOrigin}
                value={variableObj.posY ? variableObj.posY : ""}
                label="origin-y"
                type="number"
                id={`text-y-${i}`}
                onChange={(value) => {
                  variableObj.posY = value;
                  props.onTableRowChange(variableObj);
                  onYoriginChange();
                }}
              />
            </Cell>
            {variableObj.inputType === "components" ? (
              <>
              {variableObj.variableType === "RANGE" ? (
                  <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      error={errorYmin}
                      value={variableObj.yMin}
                      label="y-min"
                      type="number"
                      id={`text-y-${i}`}
                      onChange={(value) => {
                        variableObj.yMin = value;
                        props.onTableRowChange(variableObj);
                        onYminChange();
                      }}
                      helpText={errorYmin ? yminHelperText:"y-component min "}
                    />
                  </Cell>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      error={errorYmax}
                      value={variableObj.yMax}
                      label="y-max"
                      type="number"
                      id={`text-y-${i}`}
                      onChange={(value) => {
                        variableObj.yMax = value;
                        props.onTableRowChange(variableObj);
                        onYmaxChange();
                      }}
                      helpText={errorYmax ? ymaxHelperText:"y-component max"}
                    />
                  </Cell>
                  </React.Fragment>
                ) : <ListValuesSection 
                        variableObj={variableObj}
                        field="yList"
                        fieldName="List for Y"
                        placeholder='Enter list values seperated by comma " , " '
                        helpText="Enter values seperated by comma eg: 1,2.5,3,4,5"
                        onTableRowChange={props.onTableRowChange}
                  />}
              </>) : (<>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error={errorAngmin}
                    value={variableObj.angleMin}
                    label="angle-min"
                    type="number"
                    id={`angle-min-${i}`}
                    onChange={(value) => {
                      variableObj.angleMin = value ? value : 0;
                      props.onTableRowChange(variableObj);
                      onAngminChange();
                    }}
                    helpText={errorAngmin ? angminHelperText:"angle component of vector"}
                  />
                </Cell>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error={errorAngmax}
                    value={variableObj.angleMax}
                    label="angle-max"
                    type="number"
                    id={`angle-max-${i}`}
                    onChange={(value) => {
                      variableObj.angleMax =  value ? value : 0;
                      props.onTableRowChange(variableObj);
                      onAngmaxChange();
                    }}
                    helpText={errorAngmax ? angmaxHelperText:"angle component of vector"}
                  />
                </Cell>
              </>
            )}

          {(variableObj.variableType === "RANGE") || (variableObj.inputType === "angle-magnitude") ? (
                <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      id="text-black-list-y"
                      label={`Excluded List for ${
                        variableObj.inputType === "components" ? "Y" : "angle"
                      }`}
                      placeholder="Multiple values must be comma separated"
                      type="text"
                      helpText="comma separated"
                      onChange={(value) => {
                        variableObj[getsecondInput(variableObj.inputType)] = value;
                        props.onTableRowChange(variableObj);
                      }}
                      value={variableObj[getsecondInput(variableObj.inputType)] || ""}
                    />
                  </Cell>
                </React.Fragment>
              ) : null}
          </Grid>
      </React.Fragment>
  )
};

const AngleOptions = ({ variableObj, i, props, visible }) => {
  let angleOptions = variableObj ? variableObj.angleOptions : {};
  if (!angleOptions) {
    {
      angleOptions = {};
    }
  }

  const getHelpText = () => {
    return <p className="custom-tooltip-text">{
      AngleDisplayOptions.map((array, index) => {
        return (<p>Option{index + 1}: {array.label}</p>)
      })}
    </p>
  }

  if (visible) {
    return (
      <React.Fragment>
        <Grid>
          <Cell size={4}>
            <SelectField
              helpText="Select a Angle Display Option"
              id={`angle-option-${i}`}
              label="Angle Display Options"
              onChange={(value) => {
                angleOptions = { ...angleOptions, type: value };
                variableObj.angleOptions = angleOptions;
                props.onTableRowChange(variableObj);
              }}
              menuItems={[1, 2, 3]}
              value={angleOptions.type}
            />
            <Button
              className="nocqcStyle"
              icon
              tooltipLabel={getHelpText()}
            >
              help
            </Button>
          </Cell>
          <Cell size={4}>
            <TextField
              id={`angle-offset-${i}`}
              label="angle offset from base angle"
              placeholder="Offset Angle"
              type="number"
              helpText="The base angle is with reference to x axis, change offset value to change it"
              onChange={(value) => {
                angleOptions = {
                  ...angleOptions,
                  angleOffset: value ? parseFloat(value): '',
                };
                variableObj.angleOptions = angleOptions;
                props.onTableRowChange(variableObj);
              }}
              value={angleOptions.angleOffset}
            />
          </Cell>
          <Cell size={4}>
            <label
              htmlFor={`show-angle-clockwise-${i}`}
              className="vectors-toggle-label"
            >
              {"Angle Direction Clockwise"}
            </label>
            <Toggle
              icons={false}
              width={230}
              id={`show-angle-clockwise-${i}`}
              name="Angle Direction"
              onChange={(event) => {
                angleOptions = {
                  ...angleOptions,
                  clockwise: event.target.checked,
                };
                variableObj.angleOptions = angleOptions;
                props.onTableRowChange(variableObj);
              }}
              checked={angleOptions.clockwise}
            />
          </Cell>
        </Grid>
      </React.Fragment>
    );
  } else {
    return null;
  }
};

export default VectorVariableOption;

export const createEmptyVectorAnswerFormula = (index) => {
  return {
    name: "",
    formulaType: "components",
    angleFormula: "",
    formulaColor: "#000000", //getColorsArrayDisPlayOrder(index),
    magFormula: "",
    xFormula: "",
    yFormula: "",
    posX: "0",
    posY: "0",
    showComponents: false,
    xOrigin: "5",
    yOrigin: "5",
    autoOrigin: true,
  };
};

export const VectorQuestionHelp = function (props) {
  return [
    <div className="image-resize-warning RTWrapper" key="help-text-1">
      <p>
        <b>Help :</b> Enter vector variable names inside square bracket '[]'. To
        use latex mode, you must use $[ ]$ eg: What is $[\vec&#123;A&#125;]$ $+$
        $[\vec&#123;B&#125;]$?
      </p>
    </div>,
    <br key="help-text-br"></br>,
  ];
};
